var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.454,
    height: 48.484,
    viewBox: "0 0 45.454 48.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-exit",
    "data-name": "Icon metro-exit",
    d: "M38.934,32.231V26.17H23.782V20.11H38.934V14.049l9.091,9.091ZM35.9,29.2V41.321H20.752v9.091L2.571,41.321V1.928H35.9V17.079h-3.03V4.958H8.631l12.121,6.061V38.291H32.873V29.2Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#c39745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon_exit.c5e4f594.svg";
export { ForwardRef as ReactComponent };